import { render, staticRenderFns } from "./sendmoney-enter-amount.vue?vue&type=template&id=9a6aeda6&"
import script from "./sendmoney-enter-amount.vue?vue&type=script&lang=js&"
export * from "./sendmoney-enter-amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports